import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/long-hurst-logo.svg")